import { z } from "zod";
export const ExternalSecurityReviewQueueV1Schema = z
    .object({
    schemaVersion: z.literal("external-security-review-queue.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalExternalSecurityReviewQueue(recordedAt) {
    return ExternalSecurityReviewQueueV1Schema.parse({
        schemaVersion: "external-security-review-queue.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=external-security-review-queue.js.map